<h2 class="av-metric-card__title">
  {{ 'app.reports.monitoring.kindComparison.title' | translate }}
</h2>
<p class="av-metric-hint m-0">{{ 'app.reports.monitoring.kindComparison.hint' | translate }}</p>
@if (isEmpty()) {
  <av-empty-state icon="bar_chart" titleKey="app.reports.monitoring.kindComparison.empty" />
} @else {
  @defer (on immediate) {
    <av-bar-chart
      class="av-kind-comparison__chart"
      labelKey="app.reports.monitoring.kindComparison.title"
      [bars]="bars()"
    />
  } @placeholder {
    <div class="av-kind-comparison__chart"></div>
  } @loading (after 200ms; minimum 400ms) {
    <div class="av-kind-comparison__chart av-chart-placeholder"></div>
  } @error {
    <av-empty-state icon="bar_chart" titleKey="shared.api.errors.default" />
  }
}
